import { render, staticRenderFns } from "./TeacherWeek.vue?vue&type=template&id=92270354"
import script from "./TeacherWeek.vue?vue&type=script&lang=js"
export * from "./TeacherWeek.vue?vue&type=script&lang=js"
import style0 from "./TeacherWeek.vue?vue&type=style&index=0&id=92270354&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports